/**
 * Generated bundle index. Do not edit.
 */

export * from './index';



// WEBPACK FOOTER //
// ../../../../../packages/router/router.ts